/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Summermodestate2Inputs */



/**
* | output |
* | --- |
* | "Summer mode state" |
*
* @param {Ahu_History_Key_Summermodestate2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_summermodestate2 = /** @type {((inputs?: Ahu_History_Key_Summermodestate2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Summermodestate2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Summer mode state")
	return /** @type {LocalizedString} */ ("État mode été")
});
export { ahu_history_key_summermodestate2 as "ahu_history_key_summerModeState" }